<template>
    <div class="container-computer-service-point">
        <div class="header">
            <div class="header-title">
                Computador como Ponto de atendimento
            </div>

            <div class="header-subtitle">
                Ao definir este computador como um ponto de atendimento você terá acessa às páginas e recursos do controle definido nas configurações do lançamento.
            </div>

            <div class="header-cog">
                <ui-menu-card v-if="user && user.user_group === 'admin'" icon="fal fa-cog">
                    <button
                        v-for="(menu, i) in menus"
                        :key="i"
                        type="button"
                        @click="menuHandler(menu.action)">
                        {{ menu.label }}
                    </button>
                </ui-menu-card>
            </div>
        </div>

        <div class="body">
            <div class="body-select">
                <div class="select-launch">
                    <ui-select-v2
                        v-model="form.data.launchday"
                        :data="launchdayOptions"
                        :loading="loader.launchdayOptions"
                        :required="form.fields.launchday.required"
                        design="mgb-15 br-all"
                        label="Lançamento:"
                        placeholder="Selecione"
                        item-label="name"
                        @input="launchdaySelectHandler"
                    />
                </div>
                <div class="select-service-point">
                    <ui-select-v2
                        v-model="form.data.launchday_point"
                        :data="launchdayPointOptions"
                        :loading="loader.launchdayPointOptions"
                        :required="form.fields.launchday_point.required"
                        :disabled="form.fields.launchday_point.disabled"
                        label="Ponto de atendimento:"
                        placeholder="Selecione"
                        design="mgb-15 br-all"
                        item-label="name"
                    />
                </div>
            </div>

            <div class="body-button">
                <ui-button
                    :loading="loader.save"
                    :disabled="!canSave"
                    design="md mw-150 primary"
                    @click="saveHandler">
                    Salvar definições
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { uiSelectV2 } from '@/components/ui/form'
    import { uiButton } from '@/components/ui/buttons'
    import { uiMenuCard } from "@/components/ui"

    import { launchDay } from '@/services/axios'

    import { utilMixin } from '@/mixins'

    import { mapActions, mapGetters } from 'vuex'

    const defaultFormData = () => ({
        launchday: null,
        launchday_point: null
    })

    const defaultLoader = () => ({
        save: false,
        launchdayOptions: false,
        launchdayPointOptions: false
    })

    export default {
        name: 'computer-service-point',

        components: {
            uiSelectV2,
            uiButton,
            uiMenuCard
        },

        mixins: [utilMixin],

        data() {
            return {
                form: {
                    data: { ...defaultFormData() },
                    fields: {
                        launchday: {
                            required: true
                        },
                        launchday_point: {
                            required: true,
                            disabled: true
                        }
                    }
                },
                loader: { ...defaultLoader() },
                configurations: {
                    control_routes: {
                        credenciamento: 'launch.control.accreditation',
                        chamado: 'launch.control.called',
                        reserva: 'launch.control.reservation',
                        validacao: 'launch.control.validation',
                        pagamento: 'launch.control.payment'
                    }
                },
                menus: [
                    {
                        label: 'Gerenciar Lançamento',
                        action: 'launchday_configs'
                    },
                    {
                        label: 'Limpar cache',
                        action: 'clear_cache'
                    }
                ],
                launchdayOptions: [],
                launchdayPointOptions: []
            }
        },

        computed: {
            ...mapGetters({
                definitions: 'launchDay/getDefinitions',
                user: 'auth/getUser'
            }),
            /**
             * Valida os campos do formulário e define se pode ou não salvar a configuração
             * do ponto de atendimento
             */
            canSave() {
                let valid = true

                if (!this.validateRequired('launchday')) valid = false

                if (!this.validateRequired('launchday_point')) valid = false

                return valid
            }
        },

        mounted() {
            this.loadForm()
            if (this.definitions && this.definitions.launchday) {
                this.form.data.launchday = { ...this.definitions.launchday }
                this.form.data.launchday_point = { id: this.definitions.launchday_point_id }
            }
        },

        methods: {
            ...mapActions('launchDay', ['setPreLoad', 'setDefinitions', 'clearDefinitions']),
            /**
             * Event handler que trata as ações das opções de menu
             */
            menuHandler(action) {
                if (action === 'launchday_configs') {
                    this.$router.push({ name: 'launch.management.list' })

                } else if (action === 'clear_cache') {
                    this.clearDefinitions()
                    this.form.data = { ...defaultFormData() }
                }
            },
            /**
             * Carrega os dados necessários para montar o formulário
             */
            loadForm() {
                this.setPreLoad(true)
                this.loader.launchdayOptions = true
                launchDay.getAll('')
                    .then(response => {
                        this.launchdayOptions = [...response.data]
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.setPreLoad(false)
                        this.loader.launchdayOptions = false
                    })
            },
            /**
             * Event handler que trata o evento de quando um lançamento é selecionado
             */
            launchdaySelectHandler(event) {
                /**
                 * Não precisa buscar os pontos de atendimento caso o lançamento selecionado
                 * esteja no formulário
                 */
                const defLaunchdayId = this.definitions &&
                    this.definitions.launchday &&
                    this.definitions.launchday.id
                if (!(event && event.id === defLaunchdayId) || !event) {
                    this.launchdayPointOptions = []
                    this.form.data.launchday_point = null
                    if (!event) return
                }

                this.loader.launchdayPointOptions = true
                launchDay.get('points/launchday_id', event.id)
                    .then(response => {
                        this.launchdayPointOptions = [...response.data]
                        this.form.fields.launchday_point.disabled = false
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.loader.launchdayPointOptions = false
                    })
            },
            /**
             * Trata o evento de quando o salvamento das configurações é requerido
             */
            saveHandler() {
                this.loader.save = true
                setTimeout(() => {
                    const point = { ...this.form.data.launchday_point }
                    let routeName = this.configurations.control_routes[point.control.name]

                    // Seta os dados do ponto de atendimento no localStorage
                    const launchday = { ...this.form.data.launchday }
                    /**
                     * Remove a senha configurada para o controle de pagamento, antes de salvar os dados
                     * no localStorage
                     */
                    delete launchday.attributes.password

                    const definitions = {
                        launchday,
                        launchday_point_id: point.id,
                        launchday_points: [...this.launchdayPointOptions],
                        product: { ...this.form.data.launchday.product }
                    }
                    this.setDefinitions(definitions)

                    // Redireciona para a tela do controle vinculado ao ponto selecionado
                    if (routeName) {
                        this.$router.push({ name: routeName })

                    } else {
                        this.$toastr.e('O ponto selecionado não está vinculado à um controle válido!')
                    }
                    this.loader.save = false
                }, 500)
            },
            /**
             * Valida a propriedade required dos campos do formulário
             */
            validateRequired(field, form = null) {
                const required = this.form.fields[field].required
                const value = !form ? this.form.data[field] : this.form.data[form][field]
                const validation = this.$mx_hasValue(value) || parseInt(value) === 0

                return (required && validation) || !required
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>